import { BatchTableColumn } from '@app/sharedModule/models/paginated-batch-table.model';

/**
 * Column configuration for the Fulfill screen batch table.
 * Includes backtoassign column and print action.
 */
export const FULFILL_BATCH_TABLE_COLUMNS: BatchTableColumn[] = [
  { name: '', key: 'backtoassign', minWidth: '0px', maxWidth: '0px' },
  { name: '', key: 'name', minWidth: '120px', maxWidth: '1fr' },
  { name: 'Batch details', key: 'packages', maxWidth: '1fr' },
  { name: 'Pickup', key: 'pickup', maxWidth: '0.5fr' },
  { name: 'Fulfillment status', key: 'status', minWidth: '150px', maxWidth: '1fr' },
  { name: 'Owner', key: 'owner', minWidth: '50px', maxWidth: '0.5fr' },
  { name: 'Label status', key: 'labels', minWidth: '120px', maxWidth: '1fr' },
  { name: '', key: 'print', minWidth: '90px', maxWidth: '0.5fr', columnSpecifics: { placeholder: 'Print' } },
];
